const getErrorDataMessage = (data) => {
  if (data?.error?.message) {
    return data.error.message;
  }
  if (data?.error?.validationErrors?.length) {
    return data.error.validationErrors.map((err) => err.message).join(", ");
  }
  return null;
};

export const isErrorMessage = (objValue) => {
  if (objValue?.data && typeof objValue?.data === "string") {
    return objValue.data;
  }

  if (objValue?.response?.data && typeof objValue.response.data === "object") {
    const errorMsg = getErrorDataMessage(objValue.response.data);
    if (errorMsg) return errorMsg;
  }

  if (objValue?.error) {
    let errorMessage = objValue.error.message || "An error occurred.";
    if (objValue.error.validationErrors?.length) {
      const validationMessages = objValue.error.validationErrors.map((err) => err.message).join(", ");
      return `${errorMessage} ${validationMessages}`;
    }
    return errorMessage;
  }

  if (objValue?.originalError?.message) {
    return objValue.originalError.message;
  }

  if (objValue?.response?.statusText) {
    return objValue.response.statusText;
  }

  if (typeof objValue === "string") {
    return objValue;
  }

  return "Something went wrong, please try again!";
};

